import React, {useState, useEffect} from 'react';

import { GlobalState } from "contexts/GlobalState";
import qs from "query-string";
const FILTERS_GROUPS_NAMES =  ["learning_aspect", "interest_areas", "mainSearch","degree"];
const DEGREE_NAMES =  [{firstDegree:"תואר ראשון"},{secondDegree:"תואר שני"},{diploma:"לימודי תעודה"},{drMedicine:'ד"ר לרפואה'}];

export default function useSearch(props) {
    const [globalSearch, setGlobalSearch] = GlobalState("search");

    const searchPrograms = (searchFilters) => {
      getHebrewNameByDegreeKey(searchFilters);
      let resultsNull = false; 
  
      if (!searchFilters.isSearch) {
        resultsNull = true;
      }
  
      setGlobalSearch({
          ...globalSearch,
          filters: searchFilters,
      });
  
      globalSearch.query({
          variables: {
              search: searchFilters,
          },
      });
  
      writeOurFiltersToUrl(searchFilters);
  
      if (resultsNull) {
          return null;
      }
  };
  


    const getHebrewNameByDegreeKey = (searchFilters) => {
        let degreeName="";
        let objDegree = DEGREE_NAMES.find(o => o[searchFilters.degree]);
        if(objDegree){
          degreeName=Object.values(objDegree);
          searchFilters.degree=degreeName[0];
        }
    }

    const getEnglishName=(value) =>{
      let enDegreeName="";
      DEGREE_NAMES.map(degree=>{
        let enName=getKeyByValue(degree, value);
        if(enName)
          enDegreeName=enName;
      })
      return enDegreeName;
      }
      
      const getKeyByValue=(object, value) =>{
            return Object.keys(object).find(key => object[key] === value);
      }
          
    const writeOurFiltersToUrl = (searchFilters, filtersGroupsNames=FILTERS_GROUPS_NAMES) => {
        let enDegreeName="";
        const clone = Object.assign({}, searchFilters);
        enDegreeName=getEnglishName(searchFilters.degree);
        clone.degree=enDegreeName;
        const queryString = window.location.search;
        let queryStringValues = qs.parse(queryString);
         //run on every filters group 
        filtersGroupsNames.forEach( groupName => {
          queryStringValues = Utils.setQueryStringValue(groupName, clone[groupName], queryStringValues);
        })
        if(searchFilters.degree){
        Utils.setQueryStringWithoutPageReload(queryStringValues);}
      }
      
    return { searchPrograms,writeOurFiltersToUrl};
}


  